import { render, staticRenderFns } from "./ConfirmRemoveNoteModal.vue?vue&type=template&id=4794b7ce&"
import script from "./ConfirmRemoveNoteModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmRemoveNoteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports